import { render, staticRenderFns } from "./Bathroom.vue?vue&type=template&id=19615174&"
import script from "./Bathroom.vue?vue&type=script&lang=ts&"
export * from "./Bathroom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports